import configureEnvironment, {
  crossEnv,
} from '@/core/shared/setup/configureEnvironment';
configureEnvironment();

crossEnv.CEFSHARP = 'CefSharp' in window;

if (
  crossEnv.NODE_ENV === 'development' ||
  crossEnv.NODE_ENV === 'staging' ||
  crossEnv.NODE_ENV === 'review'
) {
  crossEnv.IMPULSE_ENDPOINT = 'https://staging-session.springboardvr.com/impulse';
} else if (crossEnv.NODE_ENV === 'production') {
  crossEnv.IMPULSE_ENDPOINT = 'https://session.springboardvr.com/impulse';
}
